import React, { createContext, useState, ReactNode } from "react";
import { merge } from "lodash";
import { MatxLayoutSettings } from "app/components/MatxLayout/settings";

interface SettingsContextType {
    settings: typeof MatxLayoutSettings | any;
    updateSettings: (update: Record<string, any>) => void;
}

export const SettingsContext = createContext<SettingsContextType>({
    settings: MatxLayoutSettings,
    updateSettings: () => {},
});

interface SettingsProviderProps {
    settings?: typeof MatxLayoutSettings;
    children: ReactNode;
}

export function SettingsProvider({
    settings,
    children,
}: SettingsProviderProps) {
    const [currentSettings, setCurrentSettings] = useState(
        settings || MatxLayoutSettings
    );

    const handleUpdateSettings = (update: Record<string, any>) => {
        const merged = merge({}, currentSettings, update);
        setCurrentSettings(merged);
    };

    return (
        <SettingsContext.Provider
            value={{
                settings: currentSettings,
                updateSettings: handleUpdateSettings,
            }}
        >
            {children}
        </SettingsContext.Provider>
    );
}
